module.exports = __webpack_public_path__ + "static/img/cjt.e8c3fa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cjt.jpg
// module id = mS2A
// module chunks = 1